import { render, staticRenderFns } from "./BeneficiaryWorkingData.vue?vue&type=template&id=61f096ce&"
import script from "./BeneficiaryWorkingData.vue?vue&type=script&lang=js&"
export * from "./BeneficiaryWorkingData.vue?vue&type=script&lang=js&"
import style0 from "./BeneficiaryWorkingData.vue?vue&type=style&index=0&id=61f096ce&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports